import { useEffect, useState } from 'react';
import { IPublicUserAuthorizationDto } from 'redux/session/session';
import { currentUser$, getCurrentUser } from 'services/current-user/current-user.service';

export const useCurrentUser = (): IPublicUserAuthorizationDto | null => {
  const [currentUser, setCurrentUser] = useState<IPublicUserAuthorizationDto | null>(getCurrentUser());

  useEffect(() => {
    const subscription = currentUser$.subscribe(setCurrentUser);
    return () => subscription.unsubscribe();
  }, []);

  return currentUser;
};
